import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import classes from './DeliveryLookup.css';
import Input from '../UI/Input/Input';
import Table from '../UI/Table/Table';


class DeliveryLookup extends Component {
state = {
    filter: ''
}
    deliveryFind = (e) => {
        this.setState({filter: e.target.value});
        this.props.onGetDeliveryLookup(e.target.value);
        
    }

    render () {
        if (this.props.deliveryLookup) {
            let pl = "5px";
            var dataLookup = [];
            for (let k in this.props.deliveryLookup) {
                let entry = this.props.deliveryLookup[k];
                
                dataLookup.push({
                    oid: entry.deliveryId, data: [
                        {
                            value: entry.deliveryId,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.customer,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.address,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.status,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.driver,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.phone,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.carNumber,
                            style: { paddingLeft: pl }
                        }
                    ]
                }
                )
            }

            var headerLookup = [
                {
                    name: "Delivery",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Customer",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Address",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Status",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Driver",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Phone",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Car #",
                    style: { paddingLeft: pl }
                }
            ];

            return (
                <div className={classes.DeliveryLookup}>
                    <Input value={this.state.filter} label='Find Delivery For Order' elementType='text' changed={(event) => this.deliveryFind(event)}></Input>
                    <Table header={headerLookup} data={dataLookup}></Table>
                </div>
            );
        }
        else {
            return(
            <div className={classes.DeliveryLookup}>
                    <Input value={this.state.filter} label='Find Delivery For Order' elementType='text' changed={(event) => this.deliveryFind(event)}></Input>
                    
                </div>
            );
        }
    }
};

const mapStateToProps = state => {
 
    return {
        deliveryLookup: state.orders.deliveryLookup
    };
}

const mapDispatchToProps = dispatch => {
    return {
      onGetDeliveryLookup: (filter) => dispatch(actions.getDeliveryLookup(filter))
    };
  };


export default connect(mapStateToProps,mapDispatchToProps)(DeliveryLookup);


// WEBPACK FOOTER //
// ./src/components/DeliveryLookup/DeliveryLookup.js